export type LogLevel = 'info' | 'warn' | 'error' | 'success' | 'debug'

const COLORS: Record<LogLevel, string> = {
  info: '\x1b[36m',    // 青色
  warn: '\x1b[33m',    // 黄色
  error: '\x1b[31m',   // 红色
  success: '\x1b[32m', // 绿色
  debug: '\x1b[35m',   // 紫色
}
const RESET = '\x1b[0m'

export class Logger {
  private verbose: boolean
  constructor(verbose = false) {
    this.verbose = verbose
  }

  info(...args: any[]) {
    if (this.verbose) this.log('info', ...args)
  }
  warn(...args: any[]) {
    this.log('warn', ...args)
  }
  error(...args: any[]) {
    this.log('error', ...args)
  }
  success(...args: any[]) {
    this.log('success', ...args)
  }
  debug(...args: any[]) {
    if (this.verbose) this.log('debug', ...args)
  }
  log(level: LogLevel, ...args: any[]) {
    const color = COLORS[level] || ''
    const prefix = {
      info: '[INFO]',
      warn: '[WARN]',
      error: '[ERROR]',
      success: '[OK]',
      debug: '[DEBUG]'
    }[level]
    // eslint-disable-next-line no-console
    console.log(`${color}${prefix}${RESET}`, ...args)
  }
} 